<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>time-stopwatch-3-quarters</title>
    <path
      d="M19.506,8.689a.25.25,0,0,1,.021-.33l1.651-1.651a1,1,0,1,0-1.414-1.414L18.108,6.95a.25.25,0,0,1-.329.021A9.447,9.447,0,0,0,13.218,5.08.25.25,0,0,1,13,4.832V2.251A.25.25,0,0,1,13.25,2H15a1,1,0,1,0,0-2H9A1,1,0,0,0,9,2h1.75a.25.25,0,0,1,.25.25V4.832a.249.249,0,0,1-.218.248,9.513,9.513,0,1,0,8.724,3.609ZM12,22a7.5,7.5,0,1,1,7.5-7.5A7.508,7.508,0,0,1,12,22Z"
    />
    <path d="M12,8.5a.5.5,0,0,0-.5.5v5h-5a.5.5,0,0,0-.5.5,6,6,0,1,0,6-6Z" />
  </svg>
</template>
